import './About.css';
import React, { useRef, useState, useEffect } from 'react';
import useIntersection from '../useIntersection';

function About(props) {
  const headingRef = useRef(null);
  const missionRef = useRef(null);
  const cap1Ref = useRef(null);
  const cap2Ref = useRef(null);
  const cap3Ref = useRef(null);

  const headingInVP = useIntersection(headingRef, '0px');
  const missionInVP = useIntersection(missionRef, '0px');
  const cap1InVP = useIntersection(cap1Ref, '0px');
  const cap2InVP = useIntersection(cap2Ref, '0px');
  const cap3InVP = useIntersection(cap3Ref, '0px');

  const [show, setShow] = useState({
    heading: false, mission: false,
    cap1: false, cap2: false, cap3: false,
  });

  useEffect(() => {
    if (headingInVP) setShow(s => ({ ...s, heading: true }));
    if (missionInVP) setShow(s => ({ ...s, mission: true }));
    if (cap1InVP)    setShow(s => ({ ...s, cap1: true }));
    if (cap2InVP)    setShow(s => ({ ...s, cap2: true }));
    if (cap3InVP)    setShow(s => ({ ...s, cap3: true }));
  }, [headingInVP, missionInVP, cap1InVP, cap2InVP, cap3InVP]);

  return (
    <div className="about_container" ref={props.refProp}>

      {/* Left: full-height image */}
      <div className="about_image_col">
        <img src="assets/section-1--img.png" alt="DeepTrade Technologies" />
      </div>

      {/* Right: unified content */}
      <div className="about_content_col" ref={props.missionRefProp}>

        <h2
          className={`about_heading${show.heading ? ' about_show' : ''}`}
          ref={headingRef}
        >
          What We Do
        </h2>

        <p
          className={`about_mission${show.mission ? ' about_show' : ''}`}
          ref={missionRef}
          style={show.mission ? { transitionDelay: '0.12s' } : {}}
        >
          DeepTrade Technologies는 최신의 AI 기술과 금융 데이터를 활용해 투자에
          반영하는 AI 로보 어드바이저의 선구자로서 시장의 복잡한 패턴을 분석하여
          사용자들이 인덱스보다 X% 더 높은 수익률을 안정적으로 얻을 수 있도록
          끊임없이 노력합니다.
        </p>

        <div className="about_rule" />

        <div
          className={`about_capability${show.cap1 ? ' about_show' : ''}`}
          ref={cap1Ref}
          style={show.cap1 ? { transitionDelay: '0.1s' } : {}}
        >
          <span className="about_cap_num">01</span>
          <span className="about_cap_text">시장에서의 기회를 탐색하여 투자방법을 제시하는 SW를 제공합니다.</span>
        </div>

        <div
          className={`about_capability${show.cap2 ? ' about_show' : ''}`}
          ref={cap2Ref}
          style={show.cap2 ? { transitionDelay: '0.25s' } : {}}
        >
          <span className="about_cap_num">02</span>
          <span className="about_cap_text">투자를 위한 고도의 정량적 인공지능 기술을 사용하여 시장의 비효율을 감지합니다.</span>
        </div>

        <div
          className={`about_capability${show.cap3 ? ' about_show' : ''}`}
          ref={cap3Ref}
          style={show.cap3 ? { transitionDelay: '0.4s' } : {}}
        >
          <span className="about_cap_num">03</span>
          <span className="about_cap_text">기계학습 기술을 사용하여 거대한 시장과 금융 데이터를 분석합니다.</span>
        </div>

      </div>
    </div>
  );
}

export default About;
